import { render, staticRenderFns } from "./DetailsTicketCancellationBox.vue?vue&type=template&id=3eba64b8"
import script from "./DetailsTicketCancellationBox.vue?vue&type=script&lang=ts"
export * from "./DetailsTicketCancellationBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports